import MatriculacionModal from "../matriculacion-modal/matriculacion-modal"
import Modal from "../_common/components/Modal"
import crypto from 'crypto'
import { connect } from "react-redux"
import { h, Fragment } from "preact"
import { isMobileAgent } from "../_common/common"
import { t } from '../_i18n'
import { toastService } from "../_services/toast-service"
import { useState, useEffect } from 'preact/hooks'
import Spinner from "../_common/components/Spinner"

import './trial-banner.scss'

const TrialBanner = ({ user, studentMeta, helpModeStep }) => {
    /** Variables **/
    const isPremiumUser = studentMeta?.has_whatsapp && studentMeta?.shop_id !== 24
    const isMad = studentMeta.formative_zone === 'MAD'
    const semesterId = isMad ? 90 : 84
    const start = new Date(studentMeta.trial_start_date)
    const today = new Date()
    today.setHours(0, 0, 0, 0)
    start.setHours(0, 0, 0, 0)
    const timeDifference = today - start
    const daysDifference = Math.max(Math.floor(timeDifference / (1000 * 60 * 60 * 24)), 0)
    const expirationMessage = t("trial_expiration").replace('{DAYS}', 15 - daysDifference)

    /** States **/
    const [showModal, setShowModal] = useState(false)
    const [loadingSkeleton, setLoadingSkeleton] = useState(false)
    const [loadingContinue, setLoadingContinue] = useState(false)
    const [cartData, setCartData] = useState(null)
    const [premiumSelected, setPremiumSelected] = useState(isPremiumUser)
    const [selectedProducts, setSelectedProducts] = useState([])
    const [cartDataAlreadyLoaded, setCartDataAlreadyLoaded] = useState()
    const [toValidate, setToValidate] = useState()
    const [cartUrl, setCartUrl] = useState('')
    const [isLoading, setIsLoading] = useState(false)

    /** Lifecycle **/
    useEffect(() => {
        getCartUrl()
        const resetLoading = () => setIsLoading(false)
        window.addEventListener("pageshow", resetLoading)
        return () => window.removeEventListener("pageshow", resetLoading)
    }, [])


    /** Methods **/
    const LoadingDots = () => {
        const [dots, setDots] = useState('');

        useEffect(() => {
            const interval = setInterval(() => {
                setDots(prev => (prev.length < 3 ? prev + '.' : ''));
            }, 500);
            return () => clearInterval(interval);
        }, []);

        return (
            <span>
                <span>{t('Estamos preparando la información de tu matrícula')} </span>
                <span className="dots">{dots}</span>
            </span>
        );
    };

    const encryptString = (studentId) => {
        const cipher = crypto.createCipheriv(
            micuentaenv.ENCRYPTION_METHOD,
            adaptKey(micuentaenv.API_ADMIN_KEYWORD),
            micuentaenv.IV_ENCRYPTION_STRING
        )
        return encodeURIComponent(Buffer.from(
            cipher.update(studentId, 'utf8', 'base64') + cipher.final('base64')
        ).toString())
    }

    const adaptKey = (key) => {
        const len = 32
        if (key.length >= len) {
            return key.substring(0, len)
        } else {
            return key + Array(len - key.length + 1).join("\x00")
        }
    }


    const getCartUrl = async () => {
        try {
            const endpoint = `${micuentaenv.STUDENT_ACCOUNT_API_basePath}/get_cart_by_cis_id?cis_id=${studentMeta.cis_id}`

            const res = await fetch(endpoint, {
                headers: { accept: 'text/plain' },
                method: 'GET'
            })

            const finalUrl = await res.text()

            setCartUrl(finalUrl)
        } catch (error) {
            console.error('Error fetching cart URL:', error)
        }
    }

    const openNewWindow = () => {
        setIsLoading(true)
        window.open(cartUrl, "_self")
    }

    const getCart = async (products = []) => {
        try {
            let baseUrl =
                `${micuentaenv.STUDENT_ACCOUNT_API_basePath}/get_recommended_cart_black_friday` +
                `?s=${encryptString(user.id.toString())}` +
                `&as=${semesterId}`

            if (products && Array.isArray(products) && products.length > 0) {
                const formattedProducts = products
                    .filter(p => !!p)
                    .join(',')
                const productsEncrypted = encryptString(formattedProducts)
                baseUrl += `&fa=${productsEncrypted}`
            } else {
                const emptyEncrypted = encryptString('')
                baseUrl += `&fa=${emptyEncrypted}`
            }

            const res = await fetch(baseUrl, {
                headers: { accept: 'application/json' },
                method: 'GET'
            })

            const data = await res.json()

            if (data.code && data.code !== 200) {
                throw new Error(data.message || 'Ha ocurrido un error')
            }

            return data
        } catch (error) {
            console.error("Error en getCart:", error?.message)
            toastService.showToast({ message: "Se ha producido un error al cargar el carrito", type: 'danger' })
            setShowModal(false)
            return null
        }
    }

    const handleCloseModal = () => {
        setCartDataAlreadyLoaded(true)
        setShowModal(false)
    }

    const handleCalculateDiscount = async (products, initial) => {
        if (initial) {
            setLoadingSkeleton(true)
            const cart = await getCart()
            setLoadingSkeleton(false)

            const recommendedIds = getRecommendedProducts(cart)
            setSelectedProducts(recommendedIds)

            setCartData(cart)
        } else {
            setLoadingContinue(true)
            const cart = await getCart(products)
            setLoadingContinue(false)

            setCartData(cart)
        }
    }

    const getRecommendedProducts = (cart) => {
        if (!cart?.semesters) return []
        return cart.semesters?.flatMap(({ products }) => {
            return products
                .filter((product) => product.price > 0)
                .filter((product) => product.is_recommended)
                .map((product) => product.id_product)
        })
    }

    const handleContinue = async () => {
        if (cartData.cartUrl) {
            window.open(cartData.cartUrl, "_blank")
        }
    }

    /** Return **/
    return (
        <Fragment>
            <div className={`trial-banner txt-color-white background-danger d-flex flex-center-x flex-center-y
                ${helpModeStep && 'z-100'}
            `}>
                <Fragment>
                    <span className={isMobileAgent() && 'trial-banner__header--mobile'}>{expirationMessage}</span>
                    <a onClick={openNewWindow}>{t('Matricúlate ahora')}</a>
                </Fragment>
            </div>
            <Modal
                visible={showModal}
                closeModal={handleCloseModal}
                overlayClass="modal-overlay trial-banner-overlay"
            >
                <MatriculacionModal
                    cartData={cartData}
                    cartDataAlreadyLoaded={cartDataAlreadyLoaded}
                    isPremiumUser={isPremiumUser}
                    loadingContinue={loadingContinue}
                    loadingSkeleton={loadingSkeleton}
                    onCalculateDiscount={handleCalculateDiscount}
                    onCloseModal={handleCloseModal}
                    onContinue={handleContinue}
                    premiumSelected={premiumSelected}
                    selectedProducts={selectedProducts}
                    setLoadingContinue={setLoadingContinue}
                    setPremiumSelected={setPremiumSelected}
                    setSelectedProducts={setSelectedProducts}
                    setToValidate={setToValidate}
                    title={t('Matriculación 2025')}
                    toValidate={toValidate}
                />
            </Modal>
            <Modal
                visible={isLoading}
                bodyClass="relative p-4"
            >
                <Spinner className="mt-8" />
                <div className="trial-banner-loading-text mb-0 mt-18">
                    <LoadingDots />
                </div>
            </Modal>
        </Fragment>
    )
}

/** Redux Container **/
const TrialBannerContainer = connect(
    ({ auth, status, general }) => ({
        user: auth.loggedUser,
        studentMeta: status.student_meta,
        helpModeStep: general.helpModeStep
    }),
    {}
)(TrialBanner)

/** Export **/
export default TrialBannerContainer